import { GET_AGENT_LOG_BY_ID } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { AgentLog } from './getAgentLogs';

const getAgentLogByIdQueryKey = (id: string) => ['agent-log', id];

const getAgentLogById = async (
  id: string
): Promise<{
  success: boolean;
  data?: AgentLog;
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_AGENT_LOG_BY_ID(id));

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `Log not found (${response.status})`
      );
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || 'Failed to fetch log');
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getAgentLogById, type AgentLog, getAgentLogByIdQueryKey };
